export default "__VITE_ASSET__09058cea__"